module.exports = __webpack_public_path__ + "img/rw5.265a7be8.png";